import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
} from 'semantic-ui-react';
import { Popup } from '../../lib/custom-ui';
import { withPopup } from '../../lib/popup';
import api from '../../api';
import { AdminActionTypes } from '../../constants/Enums';
import moment from 'moment';

const CompanyManageActionsPopup = React.memo(({ companyId }) => {
  const [list, setList] = React.useState([]);
  useEffect(() => {
    api.getAdminUsersCompanyActions({ companyId }).then((body) => {
      setList(body.items);
    });
  }, [companyId]);

  return (
    <>
      <Popup.Header>操作记录</Popup.Header>
      <Popup.Content style={{ height: '300px', width: '500px', overflowY: 'auto' }}>
        <Table fixed celled sortable unstackable>
          <TableHeader>
            <TableRow>
              <TableHeaderCell>操作时间</TableHeaderCell>
              <TableHeaderCell width={5}>操作人</TableHeaderCell>
              <TableHeaderCell>修改内容</TableHeaderCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {list.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                <TableCell>{item.userId.username || item.userId.name}</TableCell>
                <TableCell>
                  {item.type === AdminActionTypes.UPDATE_EXPIRED
                    ? moment(item.data.original).format('YYYY-MM-DD HH:mm:ss')
                    : item.data.original}
                  ”{'=>'}“
                  {item.type === AdminActionTypes.UPDATE_EXPIRED
                    ? moment(item.data.value).format('YYYY-MM-DD HH:mm:ss')
                    : item.data.value}
                  ”
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Popup.Content>
    </>
  );
});

CompanyManageActionsPopup.propTypes = {
  companyId: PropTypes.string.isRequired,
};

export default withPopup(CompanyManageActionsPopup);
